import React from "react";
import { Phone, Mail, MapPin, CheckCircle2 } from "lucide-react";
import { company } from "../mock";

const DETAILS = [
  { key: "phone", Icon: Phone, text: company.phone, href: company.phoneHref },
  { key: "email", Icon: Mail, text: company.email, href: `mailto:${company.email}` },
  { key: "billing", Icon: Mail, text: `${company.billingEmail} (faktura)`, href: `mailto:${company.billingEmail}` },
  { key: "city", Icon: MapPin, text: company.city, href: null },
];

const PERKS = [
  "Kostnadsfri besiktning",
  "Fast pris – inga överraskningar",
  "ROT-avdrag direkt på fakturan",
];

export default function ContactInfo() {
  return (
    <div className="text-white">
      <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#8fb4ff]">Kontakta oss</p>
      <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold">Få din kostnadsfria offert</h2>
      <p className="mt-4 text-white/80 text-lg max-w-md">
        Fyll i formuläret så hör vi av oss inom en arbetsdag med en kostnadsfri besiktning
        och ett tydligt fastpris – helt utan förbindelse.
      </p>
      <div className="mt-8 space-y-4">
        {DETAILS.map(({ key, Icon, text, href }) => (
          <div key={key} className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10"><Icon className="w-5 h-5" /></div>
            {href ? <a href={href} className="font-semibold hover:underline">{text}</a> : <span className="font-semibold">{text}</span>}
          </div>
        ))}
      </div>
      <div className="mt-8 space-y-2">
        {PERKS.map((t) => (
          <div key={t} className="flex items-center gap-2 text-white/90"><CheckCircle2 className="w-5 h-5 text-[#38BDF8]" /> {t}</div>
        ))}
      </div>
    </div>
  );
}
